import React from 'react'
import FormItems from 'components/FormItems'


const List = () => (
    <section className='section'>
        <FormItems />
    </section>
)

export default List
